export interface OrgProfile {
  name: string;
  tagline: string;
  bio: string;
  avatarInitials: string;
  avatarImageUrl?: string;
}

export const orgProfile: OrgProfile = {
  name: "Xvertere",
  tagline: "Building AI-Native Tools",
  bio: "Xvertere is an organization building AI-native tools. Orion (agentic coding CLI) and Wreath (AI-powered PCB layout generation) are both shaping up to be our flagship products. Solarch is our TypeScript BaaS package.",
  avatarInitials: "XV",
  avatarImageUrl: "/xvertere logo.png",
};

export interface GithubStat {
  label: string;
  value: string;
}

export const githubStats: GithubStat[] = [
  { label: "Public Repos", value: "0" },
  { label: "Followers", value: "0" },
  { label: "Following", value: "0" },
  { label: "Location", value: "Global" },
];

export interface SocialLink {
  name: string;
  href: string;
  iconId: "github" | "linkedin" | "twitter" | "instagram" | "portfolio";
}

export const socialsData: SocialLink[] = [
  {
    name: "GitHub",
    href: "https://github.com/xvertere-org",
    iconId: "github",
  },
  {
    name: "LinkedIn",
    href: "https://www.linkedin.com/company/xvertere/",
    iconId: "linkedin",
  },
  {
    name: "Twitter / X",
    href: "https://x.com/xvertere?s=20",
    iconId: "twitter",
  },

];

export interface Maintainer {
  id: string;
  name: string;
  role: string;          // e.g. "Lead Maintainer"
  avatarInitials: string;
  avatarImageUrl?: string;
  startDate: string;     // ISO date, e.g. "2024-01-15"
  endDate: string | null; // null = current
  bio: string;
  links: {
    github?: string;
    linkedin?: string;
    twitter?: string;
    website?: string;
  };
}

export const maintainers: Maintainer[] = [
  {
    id: "manas-mishra",
    name: "Manas Mishra",
    role: "Lead Maintainer",
    avatarInitials: "MM",
    startDate: "PLACEHOLDER_DATE", // I'll fill this in
    endDate: null,
    bio: "PLACEHOLDER_BIO",        // I'll fill this in
    links: {}
  }
];
